// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/tcas-ra-response-and-phraseology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/tcas-ra-response-and-phraseology/tcas-ra-response-and-phraseology.js';

mount([g0]);
